'use strict';

var _ = require('lodash');
var PricingSummaryCommonsDataService = function PricingSummaryCommonsDataService(dataRetrieverService, dataRetrieverConstantsService, summaryDashboardLegendFilterService, currentStateCriteriaService, BenchmarkService) {
  function retrieveData() {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.PRICING_SUMMARY_SCREEN, dataRetrieverConstantsService.PRICING_SUMMARY_SNAPSHOT_DATES).retrieveData(dataRetrieverConstantsService.PRICING_SUMMARY_SNAPSHOT_DATES, searchCriteria.rules);
  }
  function isDataInSearchFilter(seachFilter, dataObject) {
    return _.isEmpty(seachFilter) || seachFilter.indexOf(dataObject) !== -1;
  }
  function filterBy(data, filterMarkets, filterPOSes, filterCabins) {
    return _.filter(data, function (d) {
      return isDataInSearchFilter(filterMarkets, d.market) && isDataInSearchFilter(filterCabins, d.cabin) && isDataInSearchFilter(filterPOSes, d.pos);
    });
  }
  function filterByDirection(data) {
    var selectedDirection = summaryDashboardLegendFilterService.getSelectedDirection();
    return _.chain(data).filter(function (d) {
      return d.direction === selectedDirection;
    }).value();
  }
  function getLegendFilters() {
    return {
      markets: summaryDashboardLegendFilterService.getSelectedMarkets(),
      poses: summaryDashboardLegendFilterService.getSelectedPoses(),
      cabins: summaryDashboardLegendFilterService.getSelectedCabins()
    };
  }
  function filterByDropdownSelection(data) {
    var legendFilter = getLegendFilters();
    if (legendFilter.markets && legendFilter.poses && legendFilter.cabins) {
      return filterBy(data, legendFilter.markets, legendFilter.poses, legendFilter.cabins);
    }
    return data;
  }
  function getSummaryDataBenchmark() {
    return retrieveData().then(filterByDirection).then(filterByDropdownSelection);
  }
  function getSummaryMarkets() {
    return retrieveData().then(function (data) {
      return _.chain(data).groupBy('market').keys().sort().value();
    });
  }
  function getSummaryData() {
    return BenchmarkService.benchmarkPromise('retrieve-snapshot-dates-chart-data', getSummaryDataBenchmark);
  }
  return {
    getSummaryData: getSummaryData,
    getSummaryMarkets: getSummaryMarkets
  };
};
PricingSummaryCommonsDataService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', 'SummaryDashboardLegendFilterService', 'CurrentStateCriteriaService', 'BenchmarkService'];
module.exports = PricingSummaryCommonsDataService;